import { useMemo } from 'react';

import { formatString } from '@hsp/utilities';

import { useTableStoreSelector } from 'components/table/hooks/context';
import { TotalProps } from 'types/components/table/components/paginator';
import { s } from 'utilities/strings';

export const useDisplayTotal = ({ totalType }: TotalProps) => {
  const numberOfPages = useTableStoreSelector((state) => state.numberOfPages);
  const page = useTableStoreSelector((state) => state.page);
  const pageSize = useTableStoreSelector((state) => state.pageSize);
  const total = useTableStoreSelector((state) => state.total);

  return useMemo(() => {
    const template = '{0} {1} {2}';
    let amount = '0';
    let calculated = '0';

    switch (totalType) {
      case 'pageCount':
        amount = numberOfPages.toString();
        calculated = `${s('Site.Page')} ${page}`;
        break;

      case 'recordCount':
        amount = total.toString();
        calculated =
          total === 0 ? '0' : `${(page - 1) * pageSize + 1} - ${page * pageSize > total ? total : page * pageSize}`;
        break;
    }

    return formatString(template, calculated.toString(), s('Site.Of').toLowerCase(), amount);
  }, [numberOfPages, page, pageSize, total, totalType]);
};
